export default __webpack_public_path__ + "static/media/close.0bc4bc72.svg";